export default {
  banner: {
    title: "关于我们",
    subtitle: "Authing 让身份管理变得简单，保护企业数据资产",
    "label-one": "用户认证",
    "label-two": "分布国家",
    "label-three": "客户服务",
    "label-four": "服务时间",
  },
  company: {
    title: "公司介绍",
    "descript-one":
      "Authing 是国内首款以开发者为中心的全场景身份云产品，集成了所有主流身份认证协议，为企业和开发者提供完善安全的用户认证和访问管理服务。Authing 被科技部认定为「2020 国家高新技术企业」，被中国信息通信研究院评选为「国内身份管理与访问控制领域创新企业」，并被录入《2019 网络安全产业白皮书》。2021 年 8 月，Authing 入选福布斯亚洲的「最值得关注公司」百强榜单。2021 年 9 月，Authing 顺利入选中国信息通信研究院「卓信大数据计划」的第三批成员单位。如今，Authing 已经在全球拥有 200 多名员工，并已为中国石油、国家电网、元气森林、招商银行、日本丰田、德高集团等国内外优秀企业打造了卓越的开发方式、高效的办公流程和安全的 IT 管理体系。",
    "descript-two":
      "Authing 的主要功能包括：单点登录、用户分析、扫码登录、多因素认证、行为审计、风险控制、跨平台设备管理、IoT  身份认证等；兼容国际各类标准协议：OAuth2.0、OIDC、SAML、AD/LDAP、WS-Fed、JWT 等；此外还有基于函数计算可以无限制拓展 Authing 能力的 Pipeline 。支持云交付和私有化部署方式，帮助企业和开发者千倍级提升生产效率。",
  },
  process: {
    title: "发展历程",
    imgUrl: "//files.authing.co/authing-website/about-company-process.png",
  },
  copyright: {
    title: "软件著作权",
  },
  form: {
    title: "想了解更多关于企业版的定价信息？",
    subtitle:
      "请填写你的联系方式，很快我们的技术专家将会与你取得联系，为你解决你遇到的问题。",
  },
  link: {
    title: "相关链接",
    website: "官网",
    doc: "开发文档",
    devCommunity: "开发者论坛",
    joinus: "加入我们",
  },
};
